
import cards from "../components/cards.vue"
import getCartNumMixin from "../mixins/getCartNum"
import { transformCateDataToCascaderData } from "../utils/utils"

export default {
  components: {
    cards
  },
  mixins: [getCartNumMixin],
  provide() {
    return {
      cascaderAsync: () => this.cascaderData
    }
  },
  props: {
    configs: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      cascaderData: [],
      breadcrumbData: []
    }
  },

  computed: {},
  watch: {},

  mounted() {
    document.title = this.$t("pageTitle.cards")
    // this.initBreadcrumb();
  },

  methods: {
    // initBreadcrumb() {
    //   let whereFrom = {
    //     name: this.$t("common.home"),
    //     path: this.MAIN_PATH_WITHOUT_LANG
    //   }
    //   let selPath = [{ name: this.$t('card.myCards') }]

    //   console.log("selPath ", selPath)
    //   this.breadcrumbData = [whereFrom, ...selPath]
    // },
    handleSearch(keyword) {
      // 跳转搜索结果页
      this.$navigation.push({
        path: "/search",
        query: {
          keyword: encodeURIComponent(keyword),
          page: 1
        }
      })
      // window.location.href = `${this.MAIN_ORIGIN}${this.MAIN_PATH}/search?keyword=${encodeURIComponent(keyword)}&page=1`
    }
  }
}
